/* Publish by EComposer at 2026-10-02 15:29:29*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7zsdd02b2sv"]=  window.__ectimmers["ecom-7zsdd02b2sv"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-7zsdd02b2sv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7zsdd02b2sv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h9rayokxz3d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h9rayokxz3d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3gqph877rer').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3gqph877rer', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q6kajwoymrm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q6kajwoymrm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9jbixvcnl29').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9jbixvcnl29', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2i2k6o6lu8h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2i2k6o6lu8h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nd3psms0vhp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nd3psms0vhp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-024f5y3l1qp2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-024f5y3l1qp2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u66gvqct0e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u66gvqct0e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xcop0b8kmo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xcop0b8kmo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bvsv5nvm29f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bvsv5nvm29f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6jfpjvtmzeo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6jfpjvtmzeo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ptj4jsh99dj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ptj4jsh99dj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l21ng4d3d78').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l21ng4d3d78', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9e605f002q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9e605f002q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2yijxi9k1ng').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2yijxi9k1ng', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tl49bwqsdl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tl49bwqsdl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rkvdkwo7wo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rkvdkwo7wo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n3lar5tnq3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n3lar5tnq3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ogaj6kvb4l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ogaj6kvb4l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ll20z84yq1c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ll20z84yq1c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cmrkxlmly').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cmrkxlmly', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jkqd200bf4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jkqd200bf4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rz3o1j5dthl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rz3o1j5dthl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ufcz6cu768f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ufcz6cu768f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s90q6dga1sn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s90q6dga1sn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0svobooupasc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0svobooupasc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gdrc46tonvg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gdrc46tonvg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-89bu9y9dr96').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-89bu9y9dr96', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-47uppy68f6w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-47uppy68f6w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u3nns99a0fe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u3nns99a0fe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hwvskxyx3a8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hwvskxyx3a8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-37rc40h9f3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-37rc40h9f3l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mu618huwtw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mu618huwtw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1dh88sjci36').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1dh88sjci36', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bc51i3vo6i8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bc51i3vo6i8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vejmcg339i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vejmcg339i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qcjhignxtag').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qcjhignxtag', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zgy5qokxh6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zgy5qokxh6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s83tx687mo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s83tx687mo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uwr6k4r8ep').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uwr6k4r8ep', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hs4xssgq0th').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hs4xssgq0th', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pgmby65ptnc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pgmby65ptnc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o9zgz40dfe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o9zgz40dfe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-quj9av1kfl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-quj9av1kfl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6is23ktzet8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6is23ktzet8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uuiyvwwprol').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uuiyvwwprol', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oxgh1bqzwab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oxgh1bqzwab', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nthjfqyim5g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nthjfqyim5g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o0m5qi43kaq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o0m5qi43kaq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0dxto9x7rn9a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0dxto9x7rn9a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-km1w0jgxvr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-km1w0jgxvr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p2v3bj8sew').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p2v3bj8sew', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wcdqwbbklys').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wcdqwbbklys', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-abziw4vem1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-abziw4vem1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sbx437eiiw9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sbx437eiiw9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2p6y7wphyhg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2p6y7wphyhg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hqneyx0q3k7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hqneyx0q3k7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-568mqtwr8ci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-568mqtwr8ci', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pvedaibpd4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pvedaibpd4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zrzl4cb2lhn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zrzl4cb2lhn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4tw73jjfxrv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4tw73jjfxrv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ghupw4eb9t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ghupw4eb9t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-35jqbpajsoh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-35jqbpajsoh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ivs513w5o0i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ivs513w5o0i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bnuw8il2rkn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bnuw8il2rkn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tltmlqofqc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tltmlqofqc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4a666uv4rx3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4a666uv4rx3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-39oof7sr0v3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-39oof7sr0v3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ajakamglxxv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ajakamglxxv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w6natzts8ba').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w6natzts8ba', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ev4uy30i0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ev4uy30i0s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l1hm707lx6o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l1hm707lx6o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tbznud29oz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tbznud29oz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ovffscqgq2d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ovffscqgq2d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h9d36pd4otn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h9d36pd4otn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-snrfjhxmotp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-snrfjhxmotp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ymeh6b3eesa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ymeh6b3eesa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4jw24u27z27').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4jw24u27z27', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a9qoyeppr6l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a9qoyeppr6l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t9hbf374thn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t9hbf374thn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cbgn5cwawo7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cbgn5cwawo7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ay2e1q9lkvo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ay2e1q9lkvo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dyv4dpqnh9l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dyv4dpqnh9l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-57f9cjejhk5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-57f9cjejhk5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1vt2jfdmjkv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1vt2jfdmjkv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1vxbsmz9edh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1vxbsmz9edh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dfjltmague9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dfjltmague9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3vinu46dsww').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3vinu46dsww', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tkono8uztvr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tkono8uztvr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dq46j2lobnm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dq46j2lobnm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hmx1itxcosd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hmx1itxcosd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u6aq6wqtbdb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u6aq6wqtbdb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mcz0w611eg8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mcz0w611eg8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-22gdqn0maswh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-22gdqn0maswh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kajjmikqsg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kajjmikqsg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0rn24q0evja').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0rn24q0evja', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hzn21kw8bz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hzn21kw8bz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0iygvr7z0bno').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0iygvr7z0bno', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w142kqlw0i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w142kqlw0i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hzq0s4rx50v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hzq0s4rx50v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ahpl3qobkfa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ahpl3qobkfa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ud16e81a8e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ud16e81a8e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7wqkz9qmibb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7wqkz9qmibb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dvhwo1zcwdj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dvhwo1zcwdj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5gx4a9qkjlq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5gx4a9qkjlq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-old0suq04mm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-old0suq04mm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g4wfs2bvdw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g4wfs2bvdw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vajrcda3y9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vajrcda3y9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6suv5lpbl2a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6suv5lpbl2a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fc8dbnfjyev').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fc8dbnfjyev', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zix9y342eu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zix9y342eu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mq7hicvd6f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mq7hicvd6f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ypwkxblrdz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ypwkxblrdz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xjymxn54vlm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xjymxn54vlm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sw0sj4qdu0c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sw0sj4qdu0c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tn0di857fj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tn0di857fj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ww4nruf7by').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ww4nruf7by', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l6tzeu2re7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l6tzeu2re7c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5cc96vhhhyv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5cc96vhhhyv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1kpvlorgpdei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1kpvlorgpdei', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vhm8v6e8uur').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vhm8v6e8uur', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dfznymlp7k4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dfznymlp7k4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qge0tgux5k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qge0tgux5k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n5h72laen0m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n5h72laen0m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-si3z0e0gy6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-si3z0e0gy6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mztdiqpy4ml').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mztdiqpy4ml', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yvkv5lij9j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yvkv5lij9j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k94tgcrtjwl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k94tgcrtjwl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wl2x0gr3jz9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wl2x0gr3jz9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9c1qrk4ap6q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9c1qrk4ap6q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-syg8w72ispj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-syg8w72ispj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t5mhc1v16vd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t5mhc1v16vd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d0rqtlkxke9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d0rqtlkxke9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8gdredtmzqa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8gdredtmzqa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a4dikx1zgcc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a4dikx1zgcc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0jkkwf8t7q7j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0jkkwf8t7q7j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4nk8pvvln4d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4nk8pvvln4d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p3wfat9pcy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p3wfat9pcy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tez4rn0v0ss').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tez4rn0v0ss', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h9a5cscbt1p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h9a5cscbt1p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aameh9byapc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aameh9byapc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zteskdwpm4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zteskdwpm4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qtxw7z7wqom').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qtxw7z7wqom', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-77x4dczpjnv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-77x4dczpjnv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tdfq76md94g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tdfq76md94g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ihrnpteiqli').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ihrnpteiqli', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l0w2vwavn8i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l0w2vwavn8i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1o39bixkbni').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1o39bixkbni', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tinhu6yuraa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tinhu6yuraa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1yy5vg6d7ki').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1yy5vg6d7ki', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-epa6blqm1p4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-epa6blqm1p4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-meqf1wghrf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-meqf1wghrf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qm1b1fin5za').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qm1b1fin5za', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rsk3b1n3un8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rsk3b1n3un8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-96mptyg4yu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-96mptyg4yu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ks2f6nara3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ks2f6nara3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ip5x779zth').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ip5x779zth', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fxanfttq83').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fxanfttq83', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-khdm1oj7dtg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-khdm1oj7dtg', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9tjvmkdlkcw"]=  window.__ectimmers["ecom-9tjvmkdlkcw"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-9tjvmkdlkcw"]["2bao7ot7f"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-9tjvmkdlkcw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9tjvmkdlkcw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8v7lqpmed7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8v7lqpmed7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z8zad2a2m4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z8zad2a2m4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nnzgd9aqa4r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nnzgd9aqa4r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zbs78oycpmo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zbs78oycpmo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jl1famyv19l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jl1famyv19l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sb47fqv0r2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sb47fqv0r2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l63tfylm1g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l63tfylm1g', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y0o2hoh152m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y0o2hoh152m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ed3ah5a8fff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ed3ah5a8fff', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bmvnz9zjhv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bmvnz9zjhv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7enxt40x35d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7enxt40x35d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-58kq3ry8h8s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-58kq3ry8h8s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iehr69xpafb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iehr69xpafb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-md3mnchqaro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-md3mnchqaro', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qonyqfs7i2j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qonyqfs7i2j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h7plrmmoph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h7plrmmoph', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n7lbtu6tjy9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n7lbtu6tjy9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99ccgirzep').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99ccgirzep', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xygxa6w1no').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xygxa6w1no', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3styj14a68j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3styj14a68j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zs1hg0nj4pd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zs1hg0nj4pd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7yarzwciu0t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7yarzwciu0t', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u7h3mut8jcf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u7h3mut8jcf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o70xsej64hq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o70xsej64hq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4fvkk2t7fl6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4fvkk2t7fl6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d7cp3r6fpr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d7cp3r6fpr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lltta173qk9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lltta173qk9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i162mgqjr7n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i162mgqjr7n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-445bbjlp8dx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-445bbjlp8dx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vb6naz6b9m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vb6naz6b9m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1eqir4imjm3i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1eqir4imjm3i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4helxi06l1e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4helxi06l1e', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cpru0tj6y2a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cpru0tj6y2a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dibb5n658fo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dibb5n658fo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4dqvf52sm33').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4dqvf52sm33', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ywngk6pdtpm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ywngk6pdtpm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ilctdwwq19d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ilctdwwq19d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6cf10a3wyd2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6cf10a3wyd2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8xcfrsgzuc3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8xcfrsgzuc3', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e5asasu564i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e5asasu564i', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-msb68wig23').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-msb68wig23', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aih9qsh8pi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aih9qsh8pi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zqcv4gw6orh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zqcv4gw6orh', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m9h6bu3bi9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m9h6bu3bi9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8mdl6tq0god').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8mdl6tq0god', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wl83ucv1tt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wl83ucv1tt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n77e9v64q3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n77e9v64q3c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ym5r5lhzt0j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ym5r5lhzt0j', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y14c3qk2r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y14c3qk2r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j790ojwyx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j790ojwyx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m0aciscqbab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m0aciscqbab', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-orspzgcepdl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-orspzgcepdl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5r4cvmqotmk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5r4cvmqotmk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lnmg8iud4rg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lnmg8iud4rg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5j9ly6voa1f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5j9ly6voa1f', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vlnrytp9phg"]=  window.__ectimmers["ecom-vlnrytp9phg"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-vlnrytp9phg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vlnrytp9phg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n081d4qbdzn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n081d4qbdzn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x15qwsa09kc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x15qwsa09kc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-01opcp1xwi7r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-01opcp1xwi7r', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hte9yrp7zee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hte9yrp7zee', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1ha6ebqyu6u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1ha6ebqyu6u', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9yqv4kgtg5r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9yqv4kgtg5r', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p9puc19qbz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p9puc19qbz', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vxrppx28wb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vxrppx28wb', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2w04fl0m1rn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2w04fl0m1rn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5spvms8mw4h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5spvms8mw4h', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6lpbbwego7v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6lpbbwego7v', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7f06ckfqwhq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7f06ckfqwhq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-apjp3b3o7pm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-apjp3b3o7pm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mnu266z5jc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mnu266z5jc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9jasjfw6xql').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9jasjfw6xql', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dlnjr2ct3fv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dlnjr2ct3fv', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wbfuc6q83l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wbfuc6q83l', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cdl18d1qf7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cdl18d1qf7', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lbq34qm16e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lbq34qm16e', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-97ts9o11s7r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-97ts9o11s7r', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5km2f2en405').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5km2f2en405', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5h5agusgpwx"]=  window.__ectimmers["ecom-5h5agusgpwx"] || {};
var n,s;let t=this.$el;if(!t)return;let e=t.querySelector("afterpay-placement.ecom-afterpay-integrate"),i=this.$el.closest(".ecom-product-form--single");if(i){let r=i.querySelector('[name="id"]');if(r&&r.dispatchEvent(new window.Event("ecomUpdate")),this.settings.show_total_price){const a=i.querySelector(".ecom-product-single__quantity-input"),l=t.querySelector(".ecom-product-single__price--sale");if(!l)return;a&&a.addEventListener("change",function(){l.innerHTML=window.EComposer.formatMoney(parseInt(l.getAttribute("data-price"))*parseInt(this.value))}),i.addEventListener("ecomVariantChange",function(c){if(c.detail.variant){const d=c.detail.variant,m=a?parseInt(a.value):1;l.setAttribute("data-price",d.price),m>1&&(l.innerHTML=window.EComposer.formatMoney(d.price*parseInt(m)))}})}}if(this.settings.enable_afterpay){let r=window.document.querySelector("#ecom-after-pay-script");if(window.afterpay_min=this.settings.lower_limit||1,r)r.dataset.analyticsEnabled=!0,r.dataset.min=(n=this.settings.lower_limit)!=null?n:1,r.dataset.max=(s=this.settings.upper_limit)!=null?s:1e3;else{let a=window.document.createElement("script");a.id="ecom-after-pay-script",a.dataset.analyticsEnabled=!0,a.dataset.min=this.settings.lower_limit||1,a.dataset.max=this.settings.upper_limit||1e3,a.src="https://js.afterpay.com/afterpay-1.x.js",window.document.head.appendChild(a)}e&&this.isLive&&window.jQuery&&window.Afterpay&&window.Afterpay.initProductPage&&window.Afterpay.initProductPage(window.jQuery)}let o=t.querySelector(".ecom-product-single__price--badges-sale");if(o&&o.dataset.haveSale=="true"){let r=o.dataset.sale,a=o.dataset.text;a=a.replace(/\{.*\}/g,r),o.innerHTML=a,o.style.display="block"}

                    });
                    
                        document.querySelectorAll('.ecom-5h5agusgpwx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5h5agusgpwx', settings: {"show_total_price":false,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uee1n1y3hs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uee1n1y3hs', settings: {"show_total_price":false,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-avk2x5of718').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-avk2x5of718', settings: {"show_total_price":false,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gk92hizyia').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gk92hizyia', settings: {"show_total_price":false,"enable_afterpay":false,"lower_limit":"100","upper_limit":"600"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wml51qj7mp"]=  window.__ectimmers["ecom-wml51qj7mp"] || {};
if(!this.$el)return;let t=this.$el;this.isLive;var e=this.id;const i=function(){const n=document.querySelectorAll(".ecom-container-lightbox-"+e);n.length&&n.forEach(function(s){const r=s.querySelector("iframe");r!=null&&(r.contentWindow.postMessage('{"method":"pause"}',"*"),r.src="");const a=s.querySelector("video");a!=null&&a.pause()})};if(t&&window.EComModal){var o=t.querySelector("[ecom-modal]");new window.EComModal(o,{cssClass:["ecom-container-lightbox-"+this.id,"ecom-html","ecom-modal","ecommodal-slide"],onOpen:function(){const n=document.querySelectorAll(".ecom-container-lightbox-"+e);n.length&&(n.forEach(function(s){const r=s.querySelector("iframe");if(r!=null){const l=r.src.replace("muted=1","muted=0").replace("mute=1","mute=0");r.src=l}const a=s.querySelector("video");a!=null&&a.play()}),window.dispatchEvent(new CustomEvent("ecom-lightbox-opened",{detail:{id:e,el:n}})))},onClose:i})}i()

                    });
                    
                        document.querySelectorAll('.ecom-wml51qj7mp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wml51qj7mp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p4f2rc1qgmd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p4f2rc1qgmd', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}